import tokiot from "./tokiot";
import amap from "./amap";
import ys from "./ys";
import dal from "./dal";

export default {
  tokiot,
  amap,
  ys,
  dal,
};
